<template>
  <v-img
    v-bind="$attrs"
    v-on="$listeners"
    :src="videoCoverImage.src"
    :srcset="videoCoverImage.srcset"
  />
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  props: {
    artworkId: {
      type: String,
      required: true,
    },
    videoId: {
      required: true,
    },
    isProfile: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      videoCoverImage: {
        src: "/static/img/video.png",
      },
    };
  },

  created() {
    this.fetchCoverImage();
  },

  methods: {
    async fetchCoverImage() {
      await handler.handle(async () => {
        const res = await artworksRepo.videoMeta(
          this.artworkId,
          this.videoId,
          this.isProfile
        );
        console.log(res.data["data"]);
        if (res.data["data"]) {
          if (res.data["data"]["src"]) {
            this.videoCoverImage.src = res.data["data"]["src"];
          }
          if (res.data["data"].srcset) {
            this.videoCoverImage.srcset = res.data["data"].srcset;
          }
        }
      });
    },
  },
};
</script>